import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["containerCSSStyles", "children"],
  _excluded2 = ["children", "contentStyles", "orientation"];
import { AbstractDeviceFrame, StyledDefaultContentWrapper, StyledDefaultInnerWrapper, StyledDefaultOuterWrapper } from './AbstractDeviceFrame';
import styled, { useTheme } from 'foundations-theming/utils';
import { AbstractDeviceTemplate } from './AbstractDeviceTemplate';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledMobileFrame = styled.svg.withConfig({
  displayName: "DeviceFrameMobile__StyledMobileFrame",
  componentId: "qccr06-0"
})(({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles);
});
const MobilePortraitFrame = props => {
  const theme = useTheme();
  const fillColor = theme.color['fill-surface-raised'];
  const strokeColor = theme.color['fill-tertiary-alt'];
  return /*#__PURE__*/_jsx(StyledMobileFrame, Object.assign({}, props, {
    children: /*#__PURE__*/_jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M1 30.503v469.994C1 516.79 14.211 530 30.507 530h237.986C284.791 530 298 516.792 298 500.497V30.503C298 14.21 284.789 1 268.493 1H30.507C14.209 1 1 14.208 1 30.503zM286.5 37.5v455.503c0 14.082-11.414 25.497-25.496 25.497H37.996c-14.081 0-25.496-11.415-25.496-25.497V37.5h274z",
        stroke: strokeColor,
        fill: fillColor
      }), /*#__PURE__*/_jsxs("g", {
        transform: "translate(120.5 20.5)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M14.716 2.464h42.638",
          stroke: strokeColor,
          strokeWidth: "2",
          strokeLinecap: "round"
        }), /*#__PURE__*/_jsx("ellipse", {
          fill: strokeColor,
          cx: "3.403",
          cy: "2.61",
          rx: "2.597",
          ry: "2.61"
        })]
      })]
    })
  }));
};
const MobileLandscapeFrame = props => {
  const theme = useTheme();
  const fillColor = theme.color['fill-surface-raised'];
  const strokeColor = theme.color['fill-tertiary-alt'];
  return /*#__PURE__*/_jsx(StyledMobileFrame, Object.assign({}, props, {
    children: /*#__PURE__*/_jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M30.503 298h469.994C516.79 298 530 284.789 530 268.493V30.507C530 14.209 516.792 1 500.497 1H30.503C14.21 1 1 14.211 1 30.507v237.986C1 284.791 14.208 298 30.503 298zM37.5 12.5h455.503c14.082 0 25.497 11.414 25.497 25.496v223.008c0 14.081-11.415 25.496-25.497 25.496H37.5v-274z",
        stroke: strokeColor,
        fill: fillColor
      }), /*#__PURE__*/_jsxs("g", {
        transform: "rotate(-90 99.5 79)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M14.716 2.464h42.638",
          stroke: strokeColor,
          strokeWidth: "2",
          strokeLinecap: "round"
        }), /*#__PURE__*/_jsx("ellipse", {
          fill: strokeColor,
          cx: "3.403",
          cy: "2.61",
          rx: "2.597",
          ry: "2.61"
        })]
      })]
    })
  }));
};
const MOBILE_DEVICE_SPECS = {
  mobilePortrait: {
    Template: MobilePortraitFrame,
    top: 37.5,
    right: 12.5,
    bottom: 12.5,
    left: 12.5,
    height: 531,
    width: 299
  },
  mobileLandscape: {
    Template: MobileLandscapeFrame,
    top: 12.5,
    right: 12.5,
    bottom: 12.5,
    left: 37.5,
    height: 299,
    width: 531
  }
};
const MobileTemplate = ({
  dimensions,
  Template,
  children
}) => {
  return /*#__PURE__*/_jsx(AbstractDeviceTemplate, {
    dimensions: dimensions,
    Template: Template,
    children: children
  });
};
const MobileInnerWrapper = ({
  dimensions,
  children
}) => {
  return /*#__PURE__*/_jsx(StyledDefaultInnerWrapper, {
    $dimensions: dimensions,
    children: children
  });
};
const MobileOuterWrapper = _ref => {
  let {
      containerCSSStyles,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledDefaultOuterWrapper, Object.assign({
    $cssStyles: Object.assign({}, containerCSSStyles)
  }, rest, {
    children: children
  }));
};
const MobileContentWrapper = ({
  contentCSSStyles,
  children
}) => {
  return /*#__PURE__*/_jsx(StyledDefaultContentWrapper, {
    $cssStyles: Object.assign({}, contentCSSStyles),
    children: children
  });
};
export const DeviceFrameMobile = _ref2 => {
  let {
      children,
      contentStyles = {},
      orientation
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    domProps,
    tokenProps: containerStyleProps
  } = filterProps(rest);
  const containerCSSStyles = useMapTokenPropsToCSS(containerStyleProps);
  const {
    tokenProps: contentStyleProps
  } = filterProps(contentStyles);
  const contentCSSStyles = useMapTokenPropsToCSS(contentStyleProps);
  const computedSpecs = orientation === 'landscape' ? MOBILE_DEVICE_SPECS.mobileLandscape : MOBILE_DEVICE_SPECS.mobilePortrait;
  return /*#__PURE__*/_jsx(AbstractDeviceFrame, {
    OuterWrapper: MobileOuterWrapper,
    containerCSSStyles: containerCSSStyles,
    contentCSSStyles: contentCSSStyles,
    ContentWrapper: MobileContentWrapper,
    InnerWrapper: MobileInnerWrapper,
    spec: computedSpecs,
    Template: MobileTemplate,
    "data-test-id": domProps['data-test-id'],
    children: children
  });
};